import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
    Package,
    Leaf,
    CupSoda,
    Banknote,
    ShoppingBag,
    Images,
    GalleryHorizontalIcon,
    Car,
     ImageMinusIcon
} from "lucide-react";
import Gallery from "./Gallery";
import {GiDramaMasks, GiMeditation} from "react-icons/gi";
import {MdMasks} from "react-icons/md";
import {BiMask} from "react-icons/bi";



const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const menuItems = [
        { name: "Home", path: "/" },
        // { name: "About Us", path: "/about" },
        // { name: "Our Activities", path: "/services" },
        { name: "Gallery", path: "/gallery" },
        { name: "Wellness", path: "/wellness" },
        { name: "Travel Packages", path: "/travel" },
        { name: "Ayurvedic Products", path: "/ayurveda" },
        { name: "Herbal Tea", path: "/tea" },
        { name: "Bank Info", path: "/bank" },

        { name: "Fabric Store", path: "/fabric" },
        { name: "Mask Museum & Antiques", path: "/masks" },
        { name: "Contact Us", path: "/contact" },
    ];

    const toggleMobileMenu = () => setIsMobileMenuOpen((prev) => !prev);

    return (
        <>
            {/* Top Navbar */}
            <nav className="bg-gray-900 text-white fixed top-0 left-0 w-full z-50 shadow-md">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center h-16">
                        <Link to="/" className="text-xl font-bold leading-tight">
                            No Limit Tour <br/> Randombe
                        </Link>
                        <button
                            className="sm:hidden text-white focus:outline-none"
                            onClick={toggleMobileMenu}
                            aria-expanded={isMobileMenuOpen}
                        >
                            {isMobileMenuOpen ? (
                                <svg
                                    className="w-6 h-6"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            ) : (
                                <svg
                                    className="w-6 h-6"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M4 6h16M4 12h16m-7 6h7"
                                    />
                                </svg>
                            )}
                        </button>
                        {/* Desktop Menu */}
                        <ul className="hidden sm:flex space-x-4">
                            {menuItems.map((item) => (
                                <li key={item.path}>
                                    <Link className="hover:text-yellow-300" to={item.path}>
                                        {item.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Mobile Slide Sidebar */}
                <div
                    className={`fixed top-0 left-0 h-full w-64 bg-blue-900 z-40 transform ${
                        isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"
                    } transition-transform duration-300 ease-in-out sm:hidden`}
                >
                    <div className="flex justify-between items-center p-4 border-b border-blue-700">
                        <span className="text-xl font-semibold">Menu</span>
                        <button onClick={toggleMobileMenu}>
                            <svg
                                className="w-6 h-6 text-white"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    </div>
                    <ul className="flex flex-col mt-2">
                        {menuItems.map((item) => (
                            <li key={item.path}>
                                <Link
                                    className="block px-6 py-3 hover:bg-blue-700 border-b border-blue-800"
                                    to={item.path}
                                    onClick={() => setIsMobileMenuOpen(false)}
                                >
                                    {item.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Overlay */}
                {isMobileMenuOpen && (
                    <div
                        onClick={toggleMobileMenu}
                        className="fixed inset-0 bg-black bg-opacity-50 z-30 sm:hidden"
                    ></div>
                )}
            </nav>

           </>
    );
};

export default Navbar;
